import styled from 'styled-components';

export const StyledMessage = styled.div`
  p {
    margin: 0;
  }
`;
